import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

import KycVerificationPage from "../components/kyc/KycVerificationPage";
import { useAuth } from "../context/AuthContext";
import { ME_QUERY_KEY } from "../hooks/queries/useMe";

const KycRoute = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { scoutData } = useAuth();

  if (scoutData?.kyc_status === "approved") {
    return <Navigate to="/scout/dashboard" replace />;
  }

  return (
    <KycVerificationPage
      onVerified={async () => {
        // The verification already invalidated the session; wait for the fresh
        // profile so the dashboard's KYC gate sees the approval.
        await queryClient.refetchQueries({ queryKey: ME_QUERY_KEY });
        navigate("/scout/dashboard", { replace: true });
      }}
    />
  );
};

export default KycRoute;
